import { logStartGreyError } from 'owa-analytics-start';
import { getRawStoreInternalOnly } from '../store/store';

export function checkGlobalSettingsReady(context?: string): void {
    const { allowDefaultDataReturn, userConfiguration } = getRawStoreInternalOnly();
    if (!allowDefaultDataReturn && userConfiguration === undefined) {
        const error = new Error('OwaSessionStoreGlobalSettingsNotReady');

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError('OwaSessionStoreGlobalSettingsNotReady', undefined, error, { context });
    }
}
